import React from 'react';
import StandaloneDetentionForm from './StandaloneDetentionForm';
import '../Style/App.css';

const StandaloneDetentionModal = ({ visible, onClose, onSubmit, loading }) => {
  if (!visible) return null;

  // Disabled click-outside-to-close to prevent accidental data loss
  // const handleOverlayClick = (e) => {
  //   // Close modal if clicking on the overlay (not the modal content)
  //   if (e.target === e.currentTarget) {
  //     onClose();
  //   }
  // };

  return (
    <div className="modalOverlay">
      <div className="modalContent" style={{ maxWidth: '900px', width: '90%', maxHeight: '90vh' }}>
        <div className="modalHeader">
          <h2>Create New Standalone Detention Record</h2>
          <button
            className="closeBtn"
            onClick={onClose}
            type="button"
          >
            &times;
          </button>
        </div>
        
        <div className="modalBody" style={{ maxHeight: 'calc(90vh - 120px)', overflowY: 'auto' }}>
          <StandaloneDetentionForm
            onSubmit={onSubmit}
            loading={loading}
          />
        </div>
      </div>
    </div>
  );
};

export default StandaloneDetentionModal;
